import { render, staticRenderFns } from "./projectsList.vue?vue&type=template&id=38ca5b1b&scoped=true&"
import script from "./projectsList.vue?vue&type=script&lang=js&"
export * from "./projectsList.vue?vue&type=script&lang=js&"
import style0 from "./projectsList.vue?vue&type=style&index=0&id=38ca5b1b&lang=scss&scoped=true&"
import style1 from "./projectsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca5b1b",
  null
  
)

export default component.exports